
import moment from "moment"

const postAccessToken = () => document.location.hash ? document.location.hash.substring(1) : null

const loadPost = (post_id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios('/api/post/' + post_id, {
			params: {
				post_access_token: postAccessToken() ? postAccessToken() : null,
				user_str_id: user_str_id ? user_str_id : null
			},
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			withCredentials: true
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const loadPostLists = (post_id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios('/api/post/' + post_id + '/lists', {
			params: {
				post_access_token: postAccessToken() ? postAccessToken() : null,
				user_str_id: user_str_id ? user_str_id : null
			},
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const previewPost = (post_id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios('/api/post/preview/' + post_id, {
			params: {
				post_access_token: postAccessToken() ? postAccessToken() : null,
				user_str_id: user_str_id ? user_str_id : null
			},
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const searchPosts = (search, withData, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/posts/search', {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			params: {
				s: search ? search : null,
				withData: withData ? 'yes' : null,
				user_str_id: user_str_id ? user_str_id : null
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const globalSearch = (query, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/search/global', {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			params: {
				query: query,
				user_str_id: user_str_id ? user_str_id : null
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const recentBy = (access_token, user_str_id, slug) => {
	return new Promise((resolve, reject) => {
		axios('/api/posts/recent-by/' + slug, {
			params: {
				user_str_id: user_str_id ? user_str_id : null
			},
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const validateUpdatePost = (post, access_token) => {
	return new Promise((resolve, reject) => {
		if(post.post_id){
			axios.post('/api/post/update/' + post.post_id, post, {headers: { Authorization: access_token ? ('Bearer ' + access_token) : null}}).then(res => resolve(res.data), res => reject(res.response.data))
		}else{
			axios.post('/api/post/validate', post).then(res => resolve(res.data), res => reject(res.response.data))
		}
	})
}

const createUpdatePost = (post, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		if(post.post_id){
			axios.post('/api/post/update/' + post.post_id, post, {
				headers: { Authorization: access_token ? ('Bearer ' + access_token) : null},
				params: { user_str_id: user_str_id ? user_str_id : null }
			}).then(res => resolve(res.data), res => reject(res.response.data))
		}else{
			axios.post('/api/post/create', post, {
				headers: { Authorization: access_token ? ('Bearer ' + access_token) : null},
				params: { user_str_id: user_str_id ? user_str_id : null }
			}).then(res => {
				var post = res.data.post
				post.post_access_token = res.data.access_token
				resolve(post)
			}, res => reject(res.response.data))
		}
	})
}

const postRepost = (post_id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/repost/' + post_id, {}, {
			headers: { Authorization: access_token ? ('Bearer ' + access_token) : null}
		}).then(res => resolve(res.data), res => reject(res.response.data))
	})
}

const postRenew = (post_id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/renew/' + post_id, {}, {
			headers: { Authorization: access_token ? ('Bearer ' + access_token) : null}
		}).then(res => resolve(res.data), res => reject(res.response.data))
	})
}

const postImport = (type, url, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/import', {
			type: type,
			url: url
		}, {
			headers: { Authorization: access_token ? ('Bearer ' + access_token) : null}
		}).then(res => resolve(res.data), res => reject(res.response.data))
	})
}

const uploadImage = (image, post_id, access_token) => {
	return new Promise((resolve, reject) => {
		const formData = new FormData();
		formData.append('image', image)
		if(postAccessToken()) formData.append('post_access_token', postAccessToken())
		const config = {
			headers: {
				'content-type': 'multipart/form-data',
				Authorization: access_token ? ('Bearer ' + access_token) : null
			},
			params: postAccessToken() ? {post_access_token: postAccessToken()} : null
		}
		axios.post('/api/post/image/' + post_id, formData, config).then(res => resolve(res.data), res => reject(res.response.data))
	})
}

const deleteImage = (image_id, post_id, access_token) => {
	return new Promise((resolve, reject) => {
		axios.delete('/api/post/image/' + post_id + '/' + image_id, {
			params: postAccessToken() ? { post_access_token: postAccessToken() } : null,
			headers: { Authorization: access_token ? ('Bearer ' + access_token) : null, Accept: 'application/json' }
		}).then(res => resolve(res.data), res => reject(res.response.data))
	})
}

const orderImages = (post_id, data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/' + post_id + '/image/order', data, {
			params: postAccessToken() ? { post_access_token: postAccessToken() } : null,
			headers: { Authorization: access_token ? ('Bearer ' + access_token) : null, Accept: 'application/json' }
		}).then(res => resolve(res.data), res => reject(res.response.data))
	})
}

const userPosts = (search, withFilterData, access_token) => {
	console.log('userPosts')
	return new Promise((resolve, reject) => {
		axios.get('/api/post/user', {
			params: {
				s: search ? search : null,
				withFilterData: withFilterData ? 'yes' : null
			},
			headers: { Authorization: 'Bearer ' + access_token }
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const postDelete = (post_id, access_token) => {
	console.log('postDelete')
	return new Promise((resolve, reject) => {
		axios.delete('/api/post/' + post_id, { headers: { Authorization: 'Bearer ' + access_token } }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response.data)
		})
	})
}

const postUndelete = (post_id, access_token) => {
	console.log('postDelete')
	return new Promise((resolve, reject) => {
		axios.post('/api/post/undelete/' + post_id, null, { headers: { Authorization: 'Bearer ' + access_token } }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response.data)
		})
	})
}

const postPublish = (post_id, access_token) => {
	return new Promise((resolve, reject) => {
		if(access_token){
			axios.post('/api/post/' + post_id, null, {
				params: postAccessToken() ? { post_access_token: postAccessToken() } : null,
				headers: { Authorization: 'Bearer ' + access_token }
			}).then(res => resolve(res.data), res => reject(res.response.data))
		}else{
			axios.post('/api/post/' + post_id + '/with-token', null, {
				params: { post_access_token: postAccessToken() },
			}).then(res => resolve(res.data), res => reject(res.response.data))
		}
	})
}

const postVerify = post_id => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/verify/' + post_id, null, {params: postAccessToken() ? {post_access_token: postAccessToken()} : null}).then(res => resolve(res.data), res => reject(res.response))
	})
}

const postReply = post_id => {
	return new Promise((resolve, reject) => {
		axios.get('/api/post/reply/' + post_id).then(res => resolve(res.data), res => reject(res.response))
	})
}

const toggleList = (post_id, type, options, access_token, user_str_id) => {
	if(!options) options = {}
	return new Promise((resolve, reject) => {
		axios.post('/api/post/' + post_id + '/list/' + type + '/toggle', {
			user_str_id: user_str_id ? user_str_id : null,
			...options
		}, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => resolve(res.data), res => reject(res.response))
	})
}

const bulkRepost = (posts, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/bulk-repost', {posts: posts}, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => resolve(res.data), res => reject(res.response))
	})
}

const bulkDelete = (posts, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/bulk-delete', {posts: posts}, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => resolve(res.data), res => reject(res.response))
	})
}

const bulkRenew = (posts, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/bulk-renew', {posts: posts}, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => resolve(res.data), res => reject(res.response))
	})
}

const similarPosts = (post_id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/post/similar-to/' + post_id, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			params: {
				user_str_id: user_str_id ? user_str_id : null
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const sellersPosts = (post_id, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/post/from-seller-of/' + post_id, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			},
			params: {
				user_str_id: user_str_id ? user_str_id : null
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export const postPaymentIntent = (id, data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/post/' + id + '/intent', data, {
			params: postAccessToken() ? {post_access_token: postAccessToken()} : null,
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}


export const postPurchase = (id, method, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post(`/api/post/${id}/purchase/${method}`, {}, {
			params: postAccessToken() ? {post_access_token: postAccessToken()} : null,
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

/* --------------------- */

const statuses = {
    0: 'Draft',
    1: 'Active',
    2: 'Deleted',
    3: 'Removed',
    4: 'Under Review',
    5: 'Draft',
    6: 'Unverified',
    7: 'On Hold, Changes Required',
    8: 'On Hold, Draft',
    9: 'On Hold, Under Review',
    10: 'Deleted',
    11: 'Expired',
    12: 'Payment Processing',
}

const isPostExpired = post => post.status == 11
const canBeRenewed = post => moment().diff(post.posted_at, 'hours') >= process.env.MIX_RENEW_AFTER_HOURS && [1, 4].includes(post.status)
const canBeDeleted = post => [0, 1].includes(post.status)
const canUndelete = post => [2].includes(post.status)
const canBeEdited = post => [0, 1, 4, 5, 6, 7, 8, 9].includes(post.status)
const canView = post => post.location_id > 0 && ![10].includes(post.status)
const canBePublished = (post, user) => ([0, 5, 8].includes(post.status) || (user && user.active == 1 && [6].includes(post.status))) && (!post.external_id || post.import_completed > 0)
const canBeReposted = post => {
	const isExpired = isPostExpired(post)
	return isExpired || (post.status == 2 && post.can_be_reposted)
}
const canPromote = post => {
	return [1].includes(post.status)
}

const arrToAmaount = options => {
	return options.reduce((accumulator, current) => accumulator + Number(current.amount), 0)
}

const shouldBePaid = (post, user) => {
	const total = arrToAmaount(post.paid_options) + arrToAmaount(post.expenses)
	return total > 0
}

const creditsOnly = (post, user) => {
	const total = arrToAmaount(post.paid_options) + arrToAmaount(post.expenses)
	return total <= user?.points_amount
}

const creditsUsed = (post, user, withCredits) => {
    const pointsAmount = user?.points_amount ? user.points_amount : 0
    return withCredits ? (pointsAmount > post.amount_to_pay ? -post.amount_to_pay : -pointsAmount) : 0
}

const currencyFormat = (value, currency) => {
	if(!currency) currency = 'USD'
	if(currency == 'USD'){
		return '$' + numberFormat(value) + ' ' + currency
	}else{
		return numberFormat(value) + ' ' + currency
	}
}
const numberFormat = value => new Intl.NumberFormat('en-US', {
	maximumFractionDigits: 2,
	minimumFractionDigits: 2
}).format(value)

const _pValue = (values, slug) => {
    return values && values.filter(pv => pv.slug == slug)[0]
}

const pValue = (values, slug) => {
    const value = _pValue(values, slug)
    if(value && value.value){
        if(value.type == 'currency'){
            return currencyFormat(value.value, value.string)
        }else{
			return value.value
        }
    }
}

export const pExtendedValue = (values, slug) => {
    const value = _pValue(values, slug)
    if(value?.extended?.converted && value.value){
        if(value.type == 'currency'){
            return currencyFormat(value.extended.converted, value.extended.currency)
        }else{
			return value.value
        }
    }
}

const getMakeModel = values => {
	const make = values && values.filter(pv => pv.slug == 'make')[0]
	const model = values && values.filter(pv => pv.slug == 'model')[0]
	if(make || model){
		const res = [make && make.value, model && model.value].map(item => item ? item.trim() : null).filter(item => item).join(' ')
		return res
	}
	return null
}

const getStatusText = status => statuses[status]

const optionsBy = (item, name) => {
    if(item && item.options && item.options[name]) return item.options[name]
    if(item && item.property && item.property.options && item.property.options[name]) return item.property.options[name]
    return null
}

const propertyBy = (post, slug) => {
    var properties = []
    post.categories.map(item => {
        item.category_properties_sorted.map(propertyItem => {
            if(propertyItem.property.slug == slug){
                properties.push(propertyItem.property)
            }
        })
    })
    post.root_categories?.map(root => {
	    root.category_properties_sorted?.map(propertyItem => {
	        if(propertyItem.property.slug == slug){
	            properties.push(propertyItem.property)
	        }
	    })
    })
    if(properties.length > 0){
        return properties[0]
    }else{
        return null
    }
}

const isPost = (post, type) => {
	return post && post.lists && post.lists.filter(post => post.type == type).length > 0
}

const clearMeta = () => {
	console.log('clearMeta')
	const selectors = [
		//'title',
		'link[rel="canonical"]',
		'meta[name="description"]',
		'meta[name="keywords"]',
		'meta[name="og:description"]',
		'meta[name="og:keywords"]',
		'meta[name="og:title"]',
		'meta[name="geo.position"]',
		'meta[name="geo.placename"]',
		'meta[name="geo.region"]',
		'meta[name="twitter:card"]',
		'meta[name="robots"]',
		'meta[property="og:image"]',
		'meta[property="og:url"]',
		'meta[property="og:type"]',
		'meta[property="og:site_name"]',
		'meta[property="geo.position"]',
		'meta[property="geo.placename"]',
		'meta[property="geo.region"]',
		'link[rel="canonical"]',
	]

	var element
	for(var i = 0; i < selectors.length; i++){
		element = document.querySelector(selectors[i]);
		if(element) element.remove();
	}
}

const truncateString = (str, num) => {
  if (str.length <= num) {
    return str
  }
  return str.slice(0, num) + '...'
}

export {
	loadPost,
	loadPostLists,
	previewPost,
	validateUpdatePost,
	createUpdatePost,
	uploadImage,
	deleteImage,
	orderImages,
	userPosts,
	postDelete,
	postUndelete,
	postPublish,
	postVerify,
	postReply,
	postImport,
	recentBy,
	postRepost,
	postRenew,
	toggleList,
	searchPosts,
	globalSearch,
	bulkRepost,
	bulkRenew,
	bulkDelete,

	pValue,
	_pValue,
	getMakeModel,
	currencyFormat,
	numberFormat,
	getStatusText,
	postAccessToken,
	optionsBy,
	propertyBy,
	isPost,

	isPostExpired,
	canBeRenewed,
	canBeReposted,
	canBeDeleted,
	canUndelete,
	canBeEdited,
	canBePublished,
	canView,
	canPromote,

	shouldBePaid,
	creditsOnly,
	creditsUsed,

	truncateString,
	clearMeta,

	sellersPosts,
	similarPosts
}